export default __webpack_public_path__ + "static/media/a037-student-t3-3.d4a7f0b9.svg";